import React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import Link from '../../helper/link'
import { parseQueryString } from '../../helper/queryString'
import { ApplicationState } from '../../redux/ApplicationState'

interface OwnProps {
    errorGroupId: string
}

interface StateProps {
    selectedHours: number
    retentionDays: number
    params: { [key: string]: string }
}

type Props = OwnProps & StateProps

export class ErrorHistogramTimerangeSelectorComponent extends React.PureComponent<Props> {
    public render() {
        const { errorGroupId, selectedHours, retentionDays } = this.props

        const ranges: Array<{ hours: number; label: string }> = [
            { hours: 2, label: '2 hours' },
            { hours: 120, label: '5 days' },
            { hours: 7 * 24, label: '7 days' },
            { hours: 14 * 24, label: '14 days' },
            { hours: 30 * 24, label: '30 days' },
        ].filter(range => range.hours / 24 <= retentionDays)

        return (
            <div className="pull-right tw-mr-24 tw-mb-8">
                Timeframe
                {ranges.map(range => (
                    <React.Fragment key={range.hours}>
                        <span className="tw-pl-8 tw-pr-8">|</span>
                        <Link
                            className={this.classes(range.hours, selectedHours)}
                            params={{ ...this.props.params, hours: range.hours, error: errorGroupId }}
                        >
                            {range.label}
                        </Link>
                    </React.Fragment>
                ))}
            </div>
        )
    }

    private classes = (hours: number, current: number): string => (hours === current ? 'tw-font-weight-bold' : 'tw-font-weight-normal')
}

export const ErrorHistogramTimerangeSelector = withRouter(
    connect<StateProps, {}, RouteComponentProps<{}> & OwnProps, ApplicationState>(
        (state, props): StateProps => {
            const params = parseQueryString(props.location.search)
            const { hours = '120' } = params
            const { retentionDays } = state.tidewaysContext.application

            return {
                selectedHours: parseInt(hours, 10),
                params,
                retentionDays,
            }
        },
    )(ErrorHistogramTimerangeSelectorComponent),
)
